import { useState } from 'react'

import { Box, Card, Text } from '@factorialco/deprecated-design-system'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'

interface Props {
  answers: { [key: string]: string }
}

export const TemporaryDisabilitiesToggle = ({ answers }: Props) => {
  const alreadySelectedEmployeeIds = answers?.temporary_disabilities_managers?.toString() || ''
  const ids = JSON.parse('[' + alreadySelectedEmployeeIds + ']')
  const enabled = answers.its_enabled?.toString() || 'false'
  const itsEnabled = JSON.parse(enabled) === true

  const currentSelectedIds = ids.flatMap((id: number) => {
    if (id) {
      return [
        {
          id: id,
          firstName: '',
          lastName: '',
          fullName: '',
        },
      ]
    } else {
      return []
    }
  })

  const [selectedEmployees, setSelectedEmployees] =
    useState<EmployeeForSelectFragmentNoAccess[]>(currentSelectedIds)

  const toggleIts = () => {
    answers['its_enabled'] = !itsEnabled ? 'true' : 'false'
  }
  const selectedEmployeeIds = selectedEmployees.flatMap((e) => (e.id ? [e.id] : [])).toString()

  useEffect(() => {
    answers['temporary_disabilities_managers'] = selectedEmployees.map((e) => e.id).toString()
  }, [selectedEmployeeIds])

  return (
    <Box width="s400" padding="s16">
      <Card>
        <Card.Title size="small">
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.absences.temporary_disabilities.title'
          )}
        </Card.Title>
        <Card.Description>
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.absences.temporary_disabilities.description'
          )}
        </Card.Description>

        <Card.ExpandableContent expanded={itsEnabled} onExpandChange={toggleIts}>
          <Box flexDirection="row" justifyContent="flexStart" alignItems="center" gap="s4">
            <Text.Normal weight="semibold">
              {i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.absences.temporary_disabilities.admins'
              )}
            </Text.Normal>

            <InformationTooltip
              information={i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.absences.temporary_disabilities.tooltip'
              )}
              icon="info-circle"
              color="grey700"
            />
          </Box>
          <EmployeeSelector
            hideSearchIcon
            value={selectedEmployees}
            multiple
            onSelect={setSelectedEmployees}
          />
        </Card.ExpandableContent>
      </Card>
    </Box>
  )
}
